import { render, staticRenderFns } from "./IotDeviceMonitoringCard.vue?vue&type=template&id=2f15babe&scoped=true"
import script from "./IotDeviceMonitoringCard.vue?vue&type=script&lang=ts"
export * from "./IotDeviceMonitoringCard.vue?vue&type=script&lang=ts"
import style0 from "./IotDeviceMonitoringCard.vue?vue&type=style&index=0&id=2f15babe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15babe",
  null
  
)

export default component.exports